import {useDispatch} from 'react-redux';
import {getEcdsVersion} from '../../../store/reducers/dicts';
import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import AgyleDictionaryField from './agyleDictionaryField';

const ECDSDictionaryField = (props) => {
    const dispatch = useDispatch();
    const version = dispatch(getEcdsVersion(props.admitDate));

    const [dict, setDict] = useState(props.options);

    useEffect(() => {
        if (!_.isEmpty(props.options)) {
            const versionCheck = props?.ecdsVersionForce || version;
            setDict(_.filter(props.options, {ecdsVersion: versionCheck}));
        }
    }, [props.options, props?.ecdsVersionForce, version]);

    const handleGroupBy = (opt) => {
        if (props.alwaysGroup) return opt.group;
        else if (version === 'V4') return opt.group;
        return null;
    };

    return (
        <AgyleDictionaryField
            {...props}
            options={dict}
            groupBy={handleGroupBy}
        />
    );
};

export default ECDSDictionaryField;
